"use strict";

exports.__esModule = true;
exports.ChainType = void 0;
let ChainType;
exports.ChainType = ChainType;
(function (ChainType) {
  ChainType["ACALA"] = "ACALA";
  ChainType["MANDALA"] = "MANDALA";
  ChainType["KARURA"] = "KARURA";
})(ChainType || (exports.ChainType = ChainType = {}));